import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'; // Import hook for navigation
import * as Constant from "../Constant";

const Kategori = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const history = useHistory(); // Hook to programmatically navigate

    // Fetch categories data from API
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(Constant.GET_CATEGORIES);
                const result = await response.json();
                if (result.status === 200 && Array.isArray(result.data)) {
                    setCategories(result.data); // Ambil data kategori dari response
                } else {
                    console.error("Unexpected API response format:", result);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    const handleCategoryClick = (category) => {
        // Navigate to the program page with the selected category
        history.push(`/programs/${category.category}`);
    };

    const getCategoryIcon = async (id) => {
        const url = `${Constant.GET_CATEGORY_ICON}/${id}`;
        try {
          const res = await fetch(url, { method: "HEAD" });
          if (res.ok) return url;
          throw new Error("Image not found");
        } catch (error) {
          return "/images/default-icon.png"; // Fallback jika error
        }
      };
      
      
    return (
        <>
            <style>
                {`
                .scroll-container {
                    display: flex;
                    gap: 20px;
                    padding: 10px;
                    overflow-x: auto;
                    padding-bottom: 10px;
                    scrollbar-width: thin;
                    scrollbar-color: #EA6022 #f1f1f1;
                }
                .scroll-container::-webkit-scrollbar {
                    height: 8px;
                    background-color: #f1f1f1;
                    border-radius: 10px;
                }
                .scroll-container::-webkit-scrollbar-thumb {
                    background-color: #EA6022;
                    border-radius: 10px;
                    border: 2px solid #f1f1f1;
                }
                .scroll-container::-webkit-scrollbar-thumb:hover {
                    background-color: #d4551d;
                }
                `}
            </style>
            <div style={styles.container}>
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <div className="scroll-container">
                        {categories.map((category, index) => (
                            <div
                                key={category.id || index}
                                style={styles.item}
                                onClick={() => handleCategoryClick(category)} // Handle category click
                            >
                                <img
                                    src={getCategoryIcon(category.id)}
                                    alt={`${category.category} icon`}
                                    style={styles.icon} // Style for category icon
                                />
                                <div style={styles.name}>{category.category}</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

const styles = {
    container: {
        padding: '20px',
        overflow: 'hidden',
    },
    item: {
        flex: '0 0 auto',
        width: '80px',
        height: '80px',
        borderRadius: '8px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column', // Align icon and name vertically
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer', // Add cursor pointer to indicate clickable element
        marginBottom: '2px',
    },
    icon: {
        width: '50%',
        height: '50%',
        marginBottom: '4px',
        filter: 'sepia(1) saturate(5) hue-rotate(-20deg)', // Ubah ke dekat warna #EA6022
    },
    name: {
        fontSize: '12px',
        color: '#333',
    },
};

export default Kategori;
    